module.exports = __webpack_public_path__ + "img/13.d2bc0d0e.svg";